var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInnovation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 131,
    viewBox: "0 0 150 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 150,
    height: 130,
    rx: 50,
    fill: "#8DAF61",
    fillOpacity: 0.54
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2561_35741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.2082 86C89.7332 80.891 92.8944 76.5348 96.0238 72.1945C96.8498 71.0574 97.6759 69.9203 98.4701 68.7672C101.615 64.2027 103.458 58.6773 103.458 52.7035C103.458 37.1203 90.9405 24.5 75.4998 24.5C60.0592 24.5 47.5415 37.1203 47.5415 52.6875C47.5415 58.6613 49.3842 64.2027 52.5295 68.7512C53.3238 69.9043 54.1498 71.0414 54.9759 72.1785C58.1212 76.5188 61.2824 80.891 62.7915 85.984H88.2082V86ZM75.4998 106.5C82.5212 106.5 88.2082 100.766 88.2082 93.6875V91.125H62.7915V93.6875C62.7915 100.766 68.4785 106.5 75.4998 106.5ZM62.7915 52.6875C62.7915 54.0969 61.6478 55.25 60.2498 55.25C58.8519 55.25 57.7082 54.0969 57.7082 52.6875C57.7082 42.7738 65.6668 34.75 75.4998 34.75C76.8978 34.75 78.0415 35.9031 78.0415 37.3125C78.0415 38.7219 76.8978 39.875 75.4998 39.875C68.4785 39.875 62.7915 45.6086 62.7915 52.6875Z",
    fill: "#436912"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2561_35741"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 82,
    fill: "white",
    transform: "translate(45 24.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovation);
export default __webpack_public_path__ + "static/media/Innovation.359005011ea788a192fa9b02dbeac6b2.svg";
export { ForwardRef as ReactComponent };